import SweetScroll from 'sweet-scroll';

/**
 * SweetScroll
 * @doc https://www.npmjs.com/package/sweet-scroll#3-initialize-sweetscroll
 */
export default class SmoothScroll {
  constructor() {
    // 財団ページかどうか
    this.isFoundation = document.querySelector('body').classList.contains('--foundation') ? true : false;
    // ページビルダーコンテナで作成された、index-linkが含まれているページかどうか
    this.indexLink = document.querySelector('.o-index-link');
    this.offset = this.getOffset();
    this.instance = new SweetScroll({
      trigger: 'a[href^="#"]',
      duration: 800,
      easing: 'easeOutQuint',
      updateURL: true,
      offset: this.offset,
      before: (_to, _$trigger, scroller) => {
        // アニメーション中ならキャンセル
        if (scroller.isAnimating) {
          scroller.stop(true);
        }
      },
    });
    // 財団ページのみ、クリックイベントを設定
    if (this.isFoundation) this.setupClickHandlers();
  }

  setupClickHandlers() {
    // アンカーリンクに対してクリックイベントを設定
    const nav = document.querySelector('.o-global-nav--foundation ul');
    const anchorLinks = nav.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        // クリック時に最新のオフセット値を取得
        this.offset = this.getOffset();
        this.instance.update({
          offset: this.offset,
        });
      });
    });
  }

  getOffset() {
    // 財団ページ
    if (this.isFoundation) {
      const header = document.querySelector('.l-header--foundation');
      let headerHeight = header.offsetHeight;
      let isScrolled = header.classList.contains('is-scrolled');
      const isMobile = window.matchMedia('(max-width: 1023px)').matches;
      if (isMobile) {
        // sp表示の場合、ヘッダーの高さを取得する際、global-navの高さを取ってきてしまうため、追従ヘッダーの高さに合わせるため、差分の22pxを引く
        headerHeight -= 22;
      } else if (!isMobile && !isScrolled) {
        // pc表示の場合も、scrollされていない場合のクリック時に、固定ヘッダーの高さを取得してしまうため、差分の62pxを引く
        headerHeight -= 62;
      }
      return headerHeight * -1;
      // コーポレートサイト(現状の設定を踏襲)
    } else {
      // ページビルダーコンテナで作成された、index-linkが含まれているページ
      if (this.indexLink) {
        return -96; // unit-9 + unit-3
      }
    }
    // それ以外は0
    return 0;
  }

  get scroller() {
    return this.instance;
  }
}
